module.exports = "/_next/static/images/xietonggongyinglian-ab83c44f2938ff4368bf0b606de335a0.png";